/**
 * Generates a random UUID.
 */
export const randomUUID = globalThis.isSecureContext
  ? // The `crypto` module is only available in secure contexts
    globalThis.crypto.randomUUID.bind(globalThis.crypto)
  : uuidV4Fallback

/**
 * Fallback for UUID v4 when not in a secure context.
 */
function uuidV4Fallback() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
